export default __webpack_public_path__ + "static/role_1-908eca01734008e4a486ff29c21e030c.png";